import React from "react";
import Marquee from "react-fast-marquee";

const Carousel = () => {
  return (
    <Marquee speed={100} gradient={false} className="mt-6">
      {[
        "slide1", "slide2", "slide3", "slide4", "slide5",
        "slide6", "slide7", "slide8", "slide9", "slide10"
      ].map((name, index) => (
        <img
          key={index}
          src={`/images/${name}.png`}
          alt={name}
          className="w-[120px] h-[120px] sm:w-[150px] sm:h-[150px] md:w-[200px] md:h-[200px] mr-5"
        />
      ))}
    </Marquee>
  );
};

export default Carousel;
